export default __webpack_public_path__ + "static/media/i1.87725f95.jpg";